module.exports = __webpack_public_path__ + "fonts/Calibre-Black.e616d4a8.woff";